import { tokens } from '@domain-group/fe-brary';
export var inputBorderColor = tokens.colors.neutral.trim.default;
export var inputBackgroundColor = tokens.colors.neutral.surface.default;
export var inputTextColor = tokens.colors.neutral.heavy.default;
export var inputHoverBorderColor = tokens.colors.neutral.trim.hover;
export var inputFocusBorderColor = tokens.colors.interactive.trim.hover;
export var inputFocusTextColor = tokens.colors.neutral.heavy.default;
export var inputDisabledBorderColor = tokens.colors.neutral.trim.default;
export var inputDisabledBackgroundColor = tokens.colors.neutral.surface.disabled;
export var inputDisabledTextColor = tokens.colors.neutral.base.disabled;
export var inputErrorBorderColor = tokens.colors.critical.trim.default;
export var inputPlaceholderTextColor = tokens.colors.neutral.medium.default;
export var transitionDuration = '200ms';
export var transitionEasing = 'ease-out';
export var transitionPreset = "".concat(transitionDuration, " background-color ").concat(transitionEasing, ", ").concat(transitionDuration, " color ").concat(transitionEasing, ", ").concat(transitionDuration, " border-color ").concat(transitionEasing, ", ").concat(transitionDuration, " opacity ").concat(transitionEasing, ", ").concat(transitionDuration, " box-shadow ").concat(transitionEasing);
export var inputVPadding = 8;
export var inputHPadding = 8;
export var floatingPaddingTop = inputVPadding * 1.7;
export var floatingPaddingBottom = 2 * inputVPadding - floatingPaddingTop;
export var inputWrapperFont = tokens.typography.body;
export var labelFont = tokens.typography.bodyBold;
export var inputFont = tokens.typography.body;
export var inputSmallFont = tokens.typography.body;
export var checkboxTileFont = tokens.typography.caption;
export var inputSmallVPadding = 2;
export var inputSmallHPadding = 5;
export var inputBorderWidth = 1;
export var inputBorder = "".concat(inputBorderWidth, "px solid ").concat(tokens.colors.neutral.trim.default);
export var inputBorderRadius = tokens.borderRadius.inner;
export var inputBorderMiniRadius = tokens.borderRadius.mini;
export var checkboxBorderRadius = tokens.borderRadius.mini;
export var sizeConfig = {
  mini: {
    paddingY: tokens.spacing.xxs,
    paddingX: tokens.spacing.xs,
    font: tokens.typography.miniBold,
    borderRadius: tokens.borderRadius.mini
  },
  small: {
    paddingY: tokens.spacing.xxs,
    paddingX: tokens.spacing.s,
    font: tokens.typography.captionBold,
    borderRadius: tokens.borderRadius.inner
  },
  regular: {
    paddingY: tokens.spacing.xs,
    paddingX: tokens.spacing.s,
    font: tokens.typography.bodyBold,
    borderRadius: tokens.borderRadius.inner
  }
};